import React from 'react';

import cs from 'classnames';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

import useNewDesign from '../lib/useNewDesign';

import SelectableButton from './SelectableButton';

const Header = ({
  isAdvancedForm,
  handleNoDetails,
  noDetails,
  children,
  title,
  noDetailsLabel,
  className,
  emptyState,
  addRow
}) => {
  const newDesign = useNewDesign();

  return (
    <div
      className={cs('flex w-full flex-col', newDesign && 'items-center justify-center', className)}>
      {!newDesign && <p className="mb-2 text-center text-lg font-500 text-primary-900">{title}</p>}
      {!newDesign && addRow?.onClick && addRow?.showButtonInCN && (
        <div
          className={cs(
            'pr-8',

            'flex w-full flex-row justify-end'
          )}>
          <Button
            text="Add another row"
            iconRight="add-circle-mono"
            variant="link"
            size="small"
            onClick={addRow?.onClick}
            data-qa="add-other-problem-btn"
            textClassName="text-primary-500 mr-1 text-sm"
          />
        </div>
      )}
      {newDesign &&
        ((noDetails === null || noDetails === undefined || noDetails) &&
        handleNoDetails &&
        emptyState ? (
          <div className="flex w-full max-w-[500px] flex-col items-center justify-center rounded-xl bg-white p-10 py-12 md:max-w-[450px]">
            <Icon icon="illustration-empty-data"></Icon>
            <p className="mb-2 text-center text-base text-primary-900">{emptyState?.title}</p>
            <p className="mb-2 text-center text-sm text-neutral-700">{emptyState?.subtitle}</p>
            <p className="mb-2 mt-3 text-center text-sm font-500 !text-primary-900">
              {emptyState?.label}
            </p>
            <div className={cs(' !grid w-full !grid-cols-2 gap-2', !noDetails ? 'mb-3' : '-mb-3')}>
              <SelectableButton
                data-qa="yes"
                label="Yes"
                isChecked={noDetails == false}
                onChange={() => handleNoDetails(false)}
              />
              <SelectableButton
                data-qa="no"
                label="No"
                isChecked={noDetails}
                onChange={() => handleNoDetails(true)}
              />
            </div>
          </div>
        ) : (
          <>
            <p
              className={cs(
                ' text-center text-xl text-primary-700',
                handleNoDetails ? 'mb-1' : 'mb-3'
              )}>
              {title}
            </p>
            {isAdvancedForm && handleNoDetails && (
              <div className="mb-3 flex w-full max-w-[500px] flex-col items-center justify-center !px-4 md:!px-6 lg:!px-6 xl:!px-6">
                <p className="mb-[1rem] mt-2 px-4 text-center text-sm text-neutral-600">
                  {noDetailsLabel}
                </p>

                <div
                  className={cs(' !grid w-full !grid-cols-2 gap-2', !noDetails ? 'mb-3' : '-mb-3')}>
                  <SelectableButton
                    data-qa="yes"
                    label="Yes"
                    isChecked={!noDetails}
                    onChange={() => handleNoDetails(false)}
                  />
                  <SelectableButton
                    data-qa="no"
                    label="No"
                    isChecked={noDetails}
                    onChange={() => handleNoDetails(true)}
                  />
                </div>
              </div>
            )}
          </>
        ))}

      {(!emptyState && !noDetails) ||
      (noDetails === false && isAdvancedForm) ||
      !handleNoDetails ||
      !newDesign
        ? children
        : null}

      {((!emptyState && !noDetails) ||
        (noDetails === false && isAdvancedForm) ||
        !handleNoDetails) &&
        addRow &&
        newDesign && (
          <div className="mb-3 mt-3 flex w-full max-w-[500px] flex-col items-center justify-center !px-4 md:!px-6 lg:!px-6 xl:!px-6">
            <p className="mb-[1rem] mt-2 text-sm text-neutral-600">
              {addRow?.label || 'Do you want to add another row?'}
            </p>

            <div className={cs(' !grid w-full !grid-cols-2 gap-2', '-mb-3')}>
              <SelectableButton
                data-qa="yes"
                label="Yes"
                isChecked={false}
                onChange={addRow.onClick}
              />
              <SelectableButton data-qa="no" label="No" isChecked={true} onChange={() => null} />
            </div>
          </div>
        )}
    </div>
  );
};

export default Header;
